import { render, staticRenderFns } from "./CompactInput.vue?vue&type=template&id=635174d3&scoped=true&"
import script from "./CompactInput.vue?vue&type=script&lang=js&"
export * from "./CompactInput.vue?vue&type=script&lang=js&"
import style0 from "./CompactInput.vue?vue&type=style&index=0&id=635174d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635174d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VImg,VTextField})
